<template>
    <v-container fluid>
        <v-row class="pb-0 pb-sm-10">
            <v-col cols="12">
                <div class="display-1">
                    {{ action === "update" ? "Редактирование триггера" : "Создание триггера" }}
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" class="pa-6">
                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Описание триггера:</p>
                        <v-textarea
                            outlined
                            label="Описание"
                            v-model="trigger.description"
                        ></v-textarea>
                    </div>
                </v-row>

                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Событие:</p>
                        <v-select
                            v-model="trigger.event"
                            :items="events"
                            label="Выберите тип событие"
                            single-line
                            outlined
                            dense
                            item-text="description"
                            item-value="name"
                        ></v-select>
                    </div>
                </v-row>

                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Канал оповещения:</p>
                        <v-select
                            v-model="trigger.notification_type"
                            :items="types"
                            item-text="description"
                            item-value="name"
                            label="Выберите тип оповещения"
                            single-line
                            outlined
                            dense
                        ></v-select>
                    </div>
                </v-row>

                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Содержимое оповещения:</p>
                        <v-select
                            v-model="trigger.content_type"
                            :items="contentTypes"
                            item-text="description"
                            item-value="name"
                            label="Выберите содержимое оповещения"
                            single-line
                            outlined
                            dense
                        ></v-select>
                    </div>
                </v-row>

                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Задержка выполнения (в мин.):</p>
                        <v-text-field
                            label="Задержка"
                            outlined
                            dense
                            v-model.number="delayProp"
                        ></v-text-field>
                    </div>
                </v-row>
            </v-col>

            <v-col cols="6" class="pa-6">
                <v-row v-if="paramList.includes('text')">
                    <div class="w100">
                        <p class="text-field-header">Текст сообщения:</p>
                        <v-textarea
                            outlined
                            label="Описание"
                            v-model="additionalParams.text"
                        ></v-textarea>
                    </div>
                    <div class="info-box w100 mb-6">
                        <div class="w50 float-left" v-for="item in variables">
                            <p class="ma-0 pa-0">
                                <b>{{ item.variable }}</b> - {{ item.description }}
                            </p>
                        </div>
                    </div>
                </v-row>

                <v-row v-if="paramList.includes('source')">
                    <div class="w100">
                        <p class="text-field-header">Метка:</p>
                        <v-text-field
                            label="Введите источник"
                            outlined
                            dense
                            v-model.number="additionalParams.source"
                        ></v-text-field>
                    </div>
                </v-row>

                <v-row v-if="paramList.includes('offer_id')">
                    <div class="w100">
                        <p class="text-field-header">Оффер:</p>
                        <v-select
                            v-model="additionalParams.offer_id"
                            :items="offers"
                            item-text="name"
                            item-value="id"
                            label="Выберите оффер"
                            single-line
                            outlined
                            dense
                        ></v-select>
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="float-right">
                    <v-btn depressed color="primary" @click="save()">Сохранить</v-btn>
                </div>
            </v-col>
        </v-row>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-container>
</template>

<script>
import { variablesService } from "@/app/shared/services";
import triggersService from "../shared/services/triggersService";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "EditTrigger",
    props: { action: String },
    data() {
        return {
            types: triggersService.getTypes(),
            contentTypes: triggersService.getContentTypes(),
            additionalParams: {},
        };
    },
    components: {
        OverlayLoader,
    },
    created() {
        this.$store.dispatch("FETCH_EVENT_LIST", { role: "user" });
        this.$store.dispatch("GET_OFFERS");

        if (this.$route.params.id)
            this.$store
                .dispatch("FETCH_TRIGGER", this.$route.params.id)
                .then((resp) => (this.additionalParams = resp.additional_params));
    },
    computed: {
        trigger() {
            return this.$store.getters.CURRENT_TRIGGER;
        },
        isLoading() {
            return this.$store.getters.UPDATE_TRIGGER_LOADING;
        },
        events() {
            return this.$store.getters.EVENT_LIST;
        },
        offers() {
            return this.$store.getters.OFFERS;
        },
        delayProp: {
            get() {
                return this.trigger && this.trigger.delay
                    ? Math.ceil(parseInt(this.trigger.delay) / 60)
                    : 0;
            },
            set(val) {
                if (this.trigger) this.trigger.delay = parseInt(val || 0) * 60;
            },
        },
        paramList() {
            return this.trigger && this.trigger.notification_type && this.trigger.content_type
                ? triggersService.getAdditionalParams(
                      this.trigger.notification_type,
                      this.trigger.content_type
                  )
                : [];
        },
        variables() {
            return this.trigger && this.trigger.content_type
                ? variablesService.getByContent(this.trigger.content_type)
                : [];
        },
    },
    methods: {
        update(params) {
            this.$store
                .dispatch("UPDATE_TRIGGER", params)
                .then(() => {
                    this.$toast.success("Триггер успешно обновлен");
                    this.$router.push({ name: "TriggerList" });
                })
                .catch(() => this.$toast.error("Неизвестная ошибка"));
        },

        create(params) {
            this.$store
                .dispatch("CREATE_TRIGGER", params)
                .then(() => {
                    this.$toast.success("Триггер успешно создан");
                    this.$router.push({ name: "TriggerList" });
                })
                .catch(() => this.$toast.error("Неизвестная ошибка"));
        },

        save() {
            let params = Object.assign({}, this.trigger);
            params.additional_params = Object.keys(this.additionalParams)
                .filter((key) => this.paramList.includes(key))
                .reduce((obj, key) => {
                    obj[key] = this.additionalParams[key];
                    return obj;
                }, {});

            this.action === "update" ? this.update(params) : this.create(params);
        },
    },
};
</script>
